<template>
  <section class="relative p-32">
    <img
      :src="useAssets('/static/images/coming_soon.png')"
      alt="ornamento"
      class="size-full"
    />
    <div
      class="flex flex-col items-center gap-24 p-64 absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
    >
      <div class="flex items-center gap-12">
        <IconLock class="size-24 text-primary-admin" />
        <h1 class="text-headline-1 text-neutral-100 text-center">
          {{ t('moreContentComingSoon') }}
        </h1>
      </div>
      <p
        class="w-[34.5rem] text-paragraph-2 text-neutral-100 text-center"
      >
        {{ t('textContentComingSoon') }}
      </p>
    </div>
  </section>
</template>

<script setup>
import { useAssets } from 'js/utils/GLOBAL'
import { useI18n } from 'vue-i18n'
import IconLock from 'public/icons/lock.svg'

const { t } = useI18n()
</script>

<style lang="scss" scoped></style>
